<div class="card-wrapper k-mt-10">
  <div class="card">
    <div class="card-header">
      <div class="title-row">
        <div class="title k-d-flex k-align-items-center">
          <h2 class="mb-0">Betriebsausgaben</h2>
        </div>
      </div>
    </div>

    <div class="card-body">
      <div class="table-wrapper">
        <app-shive-grid #gridWrapperComponent [grid]="grid">
          <kendo-grid
            kendoGridSelectBy="id"
            scrollable="none"
            size="medium"
            [data]="gridData"
            [pageSize]="20"
            [selectable]="{ enabled: true, checkboxOnly: true }"
            [columnMenu]="{ filter: true }"
            (add)="openCostsDialog(UserOperation.Create)"
            #grid
          >
            <ng-template kendoGridToolbarTemplate>
              <div class="k-d-flex k-justify-content-end k-w-full">
                <button kendoGridAddCommand size="medium" themeColor="secondary">
                  <fa-icon class="icon turquoise k-mr-3" [icon]="faHandHoldingUsd"></fa-icon>
                  <span>Ausgabe hinzufügen</span>
                </button>
              </div>
            </ng-template>

            <kendo-grid-checkbox-column
              [width]="40"
              [headerClass]="{ 'k-text-center': true }"
              class="list-selection-check"
              [resizable]="false"
              [columnMenu]="false"
              [showSelectAll]="true"
            >
            </kendo-grid-checkbox-column>

            <kendo-grid-column field="expense_name" title="Bezeichnung">
              <ng-template kendoGridCellTemplate let-row>
                {{ row.name }}
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="expense_name" title="Datum">
              <ng-template kendoGridCellTemplate let-row>
                {{ row.due | date: "dd.MM.yyyy" }}
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="expense_name" title="Betrag">
              <ng-template kendoGridCellTemplate let-row>
                {{ row.amount | shiveCurrency }}
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="expense_tag" title="Tag">
              <ng-template kendoGridCellTemplate let-row>
                @for (tag of row.tags; track tag.id) {
                  {{ tag.name }}
                }
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="expense_due_date" title="Zahlungsziel">
              <ng-template kendoGridCellTemplate let-row>
                {{ row.due | date: "dd.MM.yyyy" }}</ng-template
              >
            </kendo-grid-column>

            <kendo-grid-column field="expense_recurrence" title="Wiederholung">
              <ng-template kendoGridCellTemplate let-row>
                {{ row.recurrence }}
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="expense_name" title="Ende">
              <ng-template kendoGridCellTemplate let-row>
                {{ row.recurrenceEnd | date: "dd.MM.yyyy" }}
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="expense_recurrence" title="Von Budget abziehen?">
              <ng-template kendoGridCellTemplate let-row>
                {{ row.deductFromBudget }}
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="expense_billable" title="Verrechenbar">
              <ng-template kendoGridCellTemplate let-row>
                {{ row.isBillable }}
              </ng-template>
            </kendo-grid-column>

            <kendo-grid-column field="expense_due_date" title="Bezahlt">
              <ng-template kendoGridCellTemplate let-row>
                {{ row.isPaid }}
              </ng-template>
            </kendo-grid-column>

            <!--            <kendo-grid-column field="expense_due_date" title="Rechnung">-->
            <!--              <ng-template kendoGridCellTemplate let-row> </ng-template>-->
            <!--            </kendo-grid-column>-->
            <!--          </kendo-grid>-->

            <kendo-grid-column [columnMenu]="false" [width]="40">
              <ng-template kendoGridCellTemplate let-dataItem>
                <app-context-menu-anchor
                  [dataItem]="dataItem"
                  [gridWrapperComponent]="gridWrapperComponent"
                />
              </ng-template>
            </kendo-grid-column>
          </kendo-grid>
        </app-shive-grid>
      </div>
    </div>
  </div>
</div>
